module.exports = __webpack_public_path__ + "img/W-2.5cdf75bf.jpg";